
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/recover",
      function () {
        return require("private-next-pages/auth/recover.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/recover"])
      });
    }
  